<div class="signin-box-container scroll-bar-css export-page">
 
  <!-- New Sign In Page -->
  <div class="signin-box-inner-container" style="display: block;">
    <div class="col-12  sign-in-text">
      <div class="lg:col-6 lg:col-offset-3 md:col-8 md:col-offset-2 sm:col-12 sm:col-offset-0 sign-in-content">
        Export Data</div>
    </div>
    <div class="col-12">
      <div class="col-12 md:col-4 lg:col-4 sm:col-12 lg:col-offset-4 md:col-offset-4 sm:col-offset-0 ">
        <p-panel>
          <div class="form-field col-12 ">
            <div class="text-center"><img src="/assets/images/temp/wim-logo.png"></div>
            <div class="form-field col-12 switch-btn" style="padding-left: 0;" translate>label_export_data_heading</div>
          </div>
        
          <div class="form-field col-12">
            <div class="form-errors alert alert-danger">
              <!-- <div *ngFor="let ErrorMessage of loginErrors['general']">
                {{ErrorMessage.message}}
              </div> -->
            </div>
          </div>
          <div class="form-field col-12">
            <div class="form-errors alert alert-danger">
              <!-- <div *ngFor="let ErrorMessage of loginErrors['email']">
                {{ErrorMessage.message}}
              </div> -->
            </div>
          </div>
         
          <form [formGroup]='signInForm'>
           
            <div class="form-field  col-12 md:col-12 lg:col-12">
              <div class="form-label">
                <label for="email-label" translate>label_security_code</label>
              </div>
              <div class="form-control">
                <div class="form-control password-show">
                  <input pInputText [type]="passwordType" id="password" formControlName="securityCode" class="full-width-transperent password-field"
                    (keypress)="eventHandler($event)" />
                  <span class="eye-icon sign-in-eye" (click)="tooglePasswordType()">
                    <i *ngIf="passwordType === 'password'" class="fa fa-fw fa-eye-slash" aria-hidden="true"></i>
                    <i *ngIf="passwordType !== 'password'" class="fa fa-fw fa-eye" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="form-errors" *ngIf="signInForm.controls.securityCode.errors  && (signInForm.controls.securityCode.dirty || signInForm.controls.securityCode.touched)">
                  <div [hidden]="!signInForm.controls.securityCode.errors.required" translate>
                    error_security_code_required
                  </div>
                  <div [hidden]="!signInForm.controls.securityCode.errors.minlength" translate>
                    securityCode_too_short
                  </div>
                  <div [hidden]="!signInForm.controls.securityCode.errors.maxlength" translate>
                    exceed_max_length
                  </div>
                </div>
              </div>
            </div>
          
            <div class="form-field col-12">
              <div class="form-field col-12 ">
                <img src=''>
              </div>
              <div class="form-field col-12 ">
                <button pButton appRipple label="{{signInLabel}}" class='sign-in-buttons' type="button" [disabled]="!signInForm.valid"
                  (click)="export()"></button>
              </div>
          
            </div>
          </form>

        </p-panel>

      </div>
    </div>

  </div>
  <!-- End Sign In Page -->
</div>

<!-- p-growl [value]="message"></p-growl -->